interface Props {
    className?: string
    FillColor?: string
}

export default function Badge({className, FillColor = 'black'}:Props) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" className={className}>
            <path
                d="M8.25 9C8.25 6.92893 9.92893 5.25 12 5.25C14.0711 5.25 15.75 6.92893 15.75 9C15.75 11.0711 14.0711 12.75 12 12.75C9.92893 12.75 8.25 11.0711 8.25 9ZM12 6.75C10.7574 6.75 9.75 7.75736 9.75 9C9.75 10.2426 10.7574 11.25 12 11.25C13.2426 11.25 14.25 10.2426 14.25 9C14.25 7.75736 13.2426 6.75 12 6.75Z"
                fill={FillColor} />
            <path
                d="M4.5 9C4.5 4.85787 7.85786 1.5 12 1.5C16.1421 1.5 19.5 4.85787 19.5 9C19.5 11.4537 18.3217 13.6322 16.5 15.0006V20.816C16.5 22.1146 14.9618 22.7997 13.9966 21.9309L12 20.134L10.0034 21.9309C9.03817 22.7997 7.5 22.1146 7.5 20.816V15.0006C5.67833 13.6322 4.5 11.4537 4.5 9ZM12 3C8.68629 3 6 5.68629 6 9C6 12.3137 8.68629 15 12 15C15.3137 15 18 12.3137 18 9C18 5.68629 15.3137 3 12 3ZM9 15.8759V20.816L12 18.116L15 20.816V15.8759C14.0813 16.2773 13.0667 16.5 12 16.5C10.9333 16.5 9.91869 16.2773 9 15.8759Z"
                fill={FillColor} />
        </svg>
    )
}
